'use client';

import { ProductVariantInterface, VariantWithQuantity } from '@qlevr/shared/interfaces';
import { useCart, useGuidedBuyingFlowBundler } from '@qlevr/shared/providers';
import { startTransition } from 'react';

export function useGuidedBuyingFlowCart() {
  const cartContext = useCart();
  const { bulkAdd } = useCart();
  const guidedBuyingFlowModal = useGuidedBuyingFlowBundler();

  const addToCartAndClose = async (variants: ProductVariantInterface[], variantWithQuantity: VariantWithQuantity[]) => {
    // Only add to cart if there are variants to add
    if (variants && variantWithQuantity && variantWithQuantity.length > 0) {
      startTransition(() => {
        bulkAdd(variants, variantWithQuantity);
      });
    }

    // Always close modal and open cart, even if no variants were added
    if (guidedBuyingFlowModal.isOpen) {
      guidedBuyingFlowModal.close();
    }

    cartContext.open();
  };

  const addToCartAndCloseModal = async (
    variants: ProductVariantInterface[],
    variantWithQuantity: VariantWithQuantity[],
  ) => {
    // Only add to cart if there are variants to add
    if (variants && variantWithQuantity && variantWithQuantity.length > 0) {
      startTransition(() => {
        bulkAdd(variants, variantWithQuantity);
      });
    }

    // Always close modal and open cart, even if no variants were added
    if (guidedBuyingFlowModal.isOpen) {
      guidedBuyingFlowModal.close();
    }

    cartContext.open();
  };

  return {
    addToCartAndClose,
    addToCartAndCloseModal,
  };
}
